import fastTracker from 'fast-tracker-browser';
import { getEnvFromQuery, getQueryParams } from '../index';
import store from '../../store';
import { FastEnvMap } from '../../config';
import config from './fast-tracker.json';

// 执行初始化
// 这里传入的环境编码如果判断不够准确的话可以不传，使用默认的prod
// 利用【环境映射】功能得到更精确的日志环境归属
let trackerInstance: any = null;

function getRecordCommonParams() {
  const query = getQueryParams();
  const orgCode = store.orgCode || query.orgCode;
  const pid = store.pid || query.pid;
  const sessionId = store.sessionId;
  const version = process.env.VERSION;

  return {
    __common__: {
      orgCode,
      pid,
      sessionId,
      version,
    },
  };
}

export const initTracker = () => {
  const env = getEnvFromQuery();
  const fastEnv = FastEnvMap[env];
  console.log(`初始化天眼环境:${fastEnv}`);
  trackerInstance = fastTracker(config, fastEnv);
};

export const reportToFast = (e: string, payload: any) => {
  const commonParams = getRecordCommonParams();
  console.log(payload);
  trackerInstance?.report(e, { ...commonParams, ...payload });
};
